import { TApplicationState } from '../../types/redux';
import { getFromDevelopersPropsCount } from './getFromDevelopersPropsCount';

export const getHasOffersFromDeveloper = (state: TApplicationState): boolean => {
  const fromDeveloperPropsCount = getFromDevelopersPropsCount(state);

  return Boolean(fromDeveloperPropsCount);
};
